import { Tile, Stack } from '@carbon/react';
import type { CarbonIconType } from '@carbon/icons-react';
import styles from './AIStatCard.module.scss';

interface AIStatCardProps {
  icon: CarbonIconType;
  title: string;
  value: string;
  color?: string;
}

export function AIStatCard({
  icon: Icon,
  title,
  value,
}: AIStatCardProps) {
  return (
    
      <Stack gap={2} orientation="horizontal" className={styles.content}>
        <div className={styles.iconContainer}>
          <Icon size={20} />
        </div>
        <Stack gap={0} className={styles.textContainer}>
          <span className={styles.statValue}>{value}</span>
          <span className={styles.statLabel}>{title}</span>
        </Stack>
      </Stack>
  );
}
